import { ReactComponentManifest } from "web/entrypoints/common/setup";
import GoogleOneTap from "web/react/components/google-one-tap/google-one-tap";
import { Feed } from "web/react/pages/feed/feed";
import withRedux from "web/react/redux-provider";

const components: ReactComponentManifest = {
    Feed: withRedux(Feed),
    GoogleOneTap: withRedux(GoogleOneTap),
};

export default components;
